export default __webpack_public_path__ + "static/media/strawberry-cake.5d499dd6.jpg";